import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { JobBoardMessagesEditComponent } from './jobboard-messages-edit';

import { BusinessService } from '../../../services/business/business.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@NgModule({
    imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    JobBoardMessagesEditComponent
],
    exports: [JobBoardMessagesEditComponent],
    providers: [BusinessService]
})

export class JobBoardMessagesEditModule {}
